import styled from "styled-components";
import { CSSVars } from "../../styles/styles.config";

export const StyledWidgetHeroLight = styled.section`
  /* The decorative platform logo and editor screenshot are scaled past the
     screen edge on purpose. Clip them here so phones do not scroll sideways.
     clip (not hidden) keeps vertical overflow and sticky headers working. */
  overflow-x: clip;

  text-align: center;
  background: #fff;
  padding: 10px 0px 50px;

  @media screen and (min-width: ${CSSVars.breakpointLG}) {
    padding: 20px 0px 50px;
  }

  header.fix-position {
    background: transparent;
    box-shadow: none;
    padding: 0 0 15px;
    border-bottom: 1px solid #e0e0e0;
    border-radius: 0;
    max-width: 1320px;
    width: 100%;
    margin: 0 auto;
    top: 0;
    left: 0;

    @media screen and (max-width: ${CSSVars.breakpointXL}) {
      padding: 0 20px 15px;
    }
  }

  .navbar-wrapper {
    max-width: 1320px;
    width: 100%;
    margin: 0 auto;
    position: relative;
    z-index: 3;

    @media screen and (max-width: ${CSSVars.breakpointXL}) {
      padding: 0 20px;
    }

    nav.fixed {
      top: 0;
      background-color: ${CSSVars.white};
      border-bottom: 1px solid #e0e0e0;

      .links {
        background-color: ${CSSVars.white};
        box-shadow: none;
        border-radius: 0;
        border: none;
        padding: 10px 0;

        .logo,
        ul a {
          color: ${CSSVars.black};
        }

        .cta-li a {
          background-color: ${CSSVars.blue500};
          color: ${CSSVars.white};
          border: none;

          &:hover {
            background-color: ${CSSVars.blue600};
          }
        }
      }
    }

    nav:not(.fixed) {
      .links {
        display: flex;
        gap: 20px;
        align-items: center;
        justify-content: space-between;
        margin: 0 auto;

        @media screen and (max-width: ${CSSVars.breakpointMD}) {
          justify-content: center;
        }

        .logo,
        ul a {
          color: ${CSSVars.black};
        }
      }
    }
  }

  .hero-wrapper {
    position: relative;
    color: ${CSSVars.black};
    display: flex;
    justify-content: space-between;
    gap: 40px;
    align-items: center;
    text-align: left;
    max-width: 1320px;
    margin: 0 auto 20px;
    width: 100%;
    min-height: 500px;

    @media screen and (max-width: ${CSSVars.breakpointMD}) {
      flex-direction: column;
      justify-content: flex-start;
      min-height: auto;
    }

    @media screen and (max-width: ${CSSVars.breakpointXL}) {
      padding: 0 20px;
    }

    > * {
      flex: 1;
      width: 50%;

      @media screen and (max-width: ${CSSVars.breakpointMD}) {
        width: 100%;
      }
    }
  }

  div.hero-text-wrapper {
    display: flex;
    flex-direction: column;
    gap: 10px;
    justify-content: flex-start;
    position: relative;
    z-index: 1;

    @media screen and (max-width: ${CSSVars.breakpointMD}) {
      justify-content: center;
      text-align: center;
      margin-top: 20px;
    }

    .hero-platform-logo {
      position: relative;
      margin-bottom: 20px;

      img {
        height: 40px !important;
        width: auto !important;
        position: relative !important;
      }
    }

    h1 {
      max-width: 100%;
      font-size: ${CSSVars.fontSize2XL};
      line-height: 1.4;
      margin: 0;
      padding: 0;
      font-weight: 600;
      max-width: 600px;

      &.coming-soon {
        position: relative;
        @media screen and (min-width: ${CSSVars.breakpointSM}) {
          width: fit-content;
        }

        &::after {
          content: "Coming Soon";
          position: absolute;
          right: -10px;
          top: -13px;
          font-size: 12px;
          padding: 5px 15px;
          border-radius: 5px;
          background-color: ${CSSVars.blue500};
          box-shadow: rgba(100, 100, 111, 0.2) 0px 7px 29px 0px;
          transform: rotate(10deg);
        }
      }
    }

    h2 {
      font-size: ${CSSVars.fontSizeLG};
      max-width: 100%;
      font-weight: 300;
      margin: 0;
      padding: 0;
      max-width: 600px;
    }

    div.button-wrapper {
      margin: 40px 0 0;
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      justify-content: flex-start;
      padding: 0;

      @media screen and (max-width: ${CSSVars.breakpointMD}) {
        justify-content: center;
        text-align: center;
        margin-top: 20px;
      }

      > a {
        margin: 20px 0;

        @media screen and (max-width: ${CSSVars.breakpointMD}) {
          margin: 20px auto;
        }
      }

      .rating-wrapper {
        margin: 20px 0 0;

        @media screen and (max-width: ${CSSVars.breakpointMD}) {
          margin: 20px auto 0;
        }

        .rating {
          > svg path {
            fill: #ffca46;
          }

          p {
            color: ${CSSVars.black};
          }
        }
      }

      @media screen and (min-width: ${CSSVars.breakpointSM}) {
        /* align-items: flex-start; */
      }

      @media screen and (min-width: ${CSSVars.breakpointMD}) {
        font-size: ${CSSVars.fontSizeXL};
      }
    }
  }

  .hero-img-wrapper {
    position: relative;
    margin: 0 auto;

    .platform-img-wrapper {
      transform: translate(0, -50%) scale(1.8);
      left: 22%;
      position: absolute;
      opacity: 0.4;

      img {
        min-height: 60px;
        max-width: 600px;
        max-height: 600px;
        object-fit: contain;
        position: relative !important;
      }
    }
  }
`;
